// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list-restart.js';

import { paths } from '../generated/list-restart';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list-restart', Original, paths);
